import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  de: {
    translation: {
      // UI Controls
      language: "Sprache",
      lightMode: "Hellmodus",
      darkMode: "Dunkelmodus",
      menu: "Menü",
      backToTop: "Nach oben",

      // Navigation
      home: "Startseite",
      services: "Leistungen",
      contact: "Kontakt",
      references: "Referenzen",
      imprint: "Impressum",
      privacy: "Datenschutz",

      // Hero Section
      heroBadge: "Ihre digitale Transformation",
      heroTitle: "Ihre IT-Lösungen für die digitale Zukunft",
      heroSubtitle:
        "Von der Prozessoptimierung bis zur Softwareentwicklung – wir bieten umfassende IT-Lösungen für Ihr Unternehmen.",
      heroCta: "Jetzt beraten lassen",
      ctaReady: "Bereit, loszulegen?",
      ctaEmail: "Schreiben Sie uns: {{email}}",

      // Services
      servicesTitle: "Unsere Leistungen",
      servicesSubtitle:
        "Von der Prozessoptimierung bis zur Softwareentwicklung – wir bieten umfassende IT-Lösungen für Ihr Unternehmen.",
      processOptimization: "Prozessoptimierung",
      processOptimizationText:
        "Workflows analysieren, Verschwendung eliminieren, Automatisierung einführen.",
      softwareDevelopment: "Softwareentwicklung",
      softwareDevelopmentText:
        "Maßgeschneiderte Web-Apps, Integrationen, Schnittstellen – passgenau für Ihr Business.",
      webSeo: "Webseiten & SEO",
      webSeoText:
        "Schnelle, konvertierende Websites mit Suchmaschinen-Optimierung.",
      automation: "Automatisierung & AI",
      automationText:
        "Bots, RPA und KI-gestützte Tools, die Routineaufgaben automatisieren.",
      itService: "IT-Service",
      itServiceText:
        "Rechner-Setup, E-Mail & Cloud, Backups, Security – zuverlässig.",
      support: "Support & Schulung",
      supportText: "Onboarding, Workshops und laufende Betreuung für Ihr Team.",
      inquire: "Anfragen",
      requestConsultation: "Kostenlose Beratung anfragen",
      freeConsultation: "Kostenloses Erstgespräch",
      viewServices: "Leistungen ansehen",
      inquirySubjectPrefix: "Anfrage:",
      learnMore: "Mehr erfahren",
      viewAllServices: "Alle Leistungen ansehen",
      servicesCtaTitle: "Bereit für den nächsten Schritt?",
      servicesCtaSubtitle:
        "Lassen Sie uns gemeinsam Ihre IT-Herausforderungen lösen und Ihr Unternehmen digital transformieren.",

      // References
      referencesTitle: "Unsere Referenzen",
      referencesSubtitle: "Ausgewählte Kundenprojekte aus Handwerk und Dienstleistung",
      referencesBadge: "Unsere Projekte",
      referenceViewDetails: "Details ansehen",
      referenceVisitSite: "Website besuchen",
      referenceTech: "Technologie-Stack",
      referenceHighlights: "Highlights",
      referenceBack: "Zurück zu Referenzen",
      referencesCtaTitle: "Ihr Projekt als nächstes?",
      referencesCtaSubtitle: "Lassen Sie uns über Ihr Projekt sprechen",
      requestProject: "Projekt anfragen",
      referenceDetailCtaTitle: "Ähnliches Projekt geplant?",
      referenceDetailCtaSubtitle: "Lassen Sie uns über Ihr Projekt sprechen",
      allReferences: "Alle Referenzen",

      // Process Steps
      processTitle: "Unser Vorgehen",
      step: "Schritt",
      step1: "Analyse",
      step1Text:
        "Wir analysieren Ihre aktuellen Prozesse und identifizieren Optimierungspotentiale.",
      step2: "Konzept",
      step2Text:
        "Gemeinsam entwickeln wir ein maßgeschneidertes Konzept für Ihre IT-Lösung.",
      step3: "Umsetzung",
      step3Text:
        "Wir setzen Ihre Lösung professionell um und begleiten Sie bei der Einführung.",
      step4: "Support",
      step4Text:
        "Laufende Betreuung und kontinuierliche Optimierung Ihrer IT-Infrastruktur.",

      // Contact
      contactTitle: "Kontaktieren Sie uns",
      contactSubtitle:
        "Haben Sie Fragen oder möchten Sie ein unverbindliches Beratungsgespräch? Wir freuen uns auf Ihre Nachricht.",
      contactPageSubtitle:
        "Lassen Sie uns über Ihr Projekt sprechen. Wir freuen uns auf Ihre Nachricht!",
      contactInformation: "Kontaktinformationen",
      name: "Name",
      email: "E-Mail",
      company: "Unternehmen",
      phone: "Telefon",
      subject: "Betreff",
      message: "Nachricht",
      send: "Nachricht senden",
      sendMessageTitle: "Nachricht senden",
      contactFormHelpText:
        "Beschreiben Sie Ihr Projekt oder Ihre Anfrage. Wir melden uns schnellstmöglich bei Ihnen zurück.",
      required: "Pflichtfeld",
      invalidEmail: "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
      invalidPhone: "Bitte geben Sie eine gültige Telefonnummer ein",
      onRequest: "Auf Anfrage",
      writeUsMessage: "Schreiben Sie uns eine Nachricht",
      feelFreeToCallUs: "Rufen Sie uns gerne an",
      location: "Standort",
      Germany: "Deutschland",
      remoteOnSitePossible: "Remote & On-Site möglich",
      itServicesAndSoftwareDevelopment: "IT-Dienstleistungen & Softwareentwicklung",
      responseTime: "Antwortzeit",
      weRespondQuickly: "Wir antworten schnell",
      responseTimeBadge: "Antwortzeit: < 24 Stunden",
      sending: "Wird gesendet...",
      allFieldsRequired: "Alle Felder mit * sind Pflichtfelder",
      nameRequired: "Name ist erforderlich",
      nameMin2: "Name muss mindestens 2 Zeichen lang sein",
      emailRequired: "E-Mail ist erforderlich",
      subjectRequired: "Betreff ist erforderlich",
      subjectMin3: "Betreff muss mindestens 3 Zeichen lang sein",
      messageRequired: "Nachricht ist erforderlich",
      messageMin6: "Nachricht muss mindestens 6 Zeichen lang sein",
      messageMin10: "Nachricht muss mindestens 10 Zeichen lang sein",
      sendError: "Fehler beim Senden",
      contactThanks24h:
        "Vielen Dank! Wir melden uns innerhalb von 24 Stunden bei Ihnen.",
      sendFailed: "Senden fehlgeschlagen. Bitte versuchen Sie es erneut.",

      // Footer
      copyright: "© 2024 webmix-it.com. Alle Rechte vorbehalten.",

      // Common
      themeToggle: "Theme wechseln",
      languageSwitch: "Sprache wechseln",
      loading: "Lädt...",
      error: "Fehler",
      errorOops: "Oops!",
      somethingWentWrong: "Etwas ist schiefgelaufen",
      success: "Erfolgreich",
      close: "Schließen",
      back: "Zurück",
      next: "Weiter",
      save: "Speichern",
      cancel: "Abbrechen",
      delete: "Löschen",
      edit: "Bearbeiten",
      view: "Anzeigen",
      search: "Suchen",
      filter: "Filter",
      sort: "Sortieren",
      refresh: "Aktualisieren",
      print: "Drucken",
      download: "Herunterladen",
      upload: "Hochladen",
      submit: "Absenden",
      reset: "Zurücksetzen",
      confirm: "Bestätigen",
      yes: "Ja",
      no: "Nein",
      ok: "OK",
      notFound: "Nicht gefunden",
      notFoundTitle: "Seite nicht gefunden",
      notFoundDescription:
        "Die angeforderte Seite konnte nicht gefunden werden.",
      notFoundGoHome: "Zur Startseite",
      notFoundGoBack: "Zurück",
      notFoundContactSupport: "Support kontaktieren",
      helpfulLinks: "Hilfreiche Links",
      goToHome: "Zur Startseite",
      exploreServices: "Leistungen",
      getHelpSupport: "Kontakt",
      tryAgain: "Erneut versuchen",
      reloadPage: "Seite neu laden",
      reportError: "Fehler melden",
      needHelp: "Benötigen Sie Hilfe?",
      contactUs: "Kontakt aufnehmen",
      errorIdLabel: "Fehler-ID",

      // Cookie Consent
      cookieSettings: "Cookie-Einstellungen",
      cookieBannerTextShort:
        "Wir verwenden Cookies, um Ihnen die beste Erfahrung auf unserer Website zu bieten",
      cookieBannerDescription:
        "Wir verwenden Cookies und ähnliche Technologien, um unsere Website zu verbessern, Ihre Präferenzen zu speichern und Ihnen personalisierte Inhalte anzuzeigen. Sie können Ihre Einstellungen jederzeit anpassen.",
      adjustSettings: "Einstellungen anpassen",
      acceptNecessary: "Nur notwendige",
      acceptAll: "Alle akzeptieren",
      chooseCookies: "Wählen Sie aus, welche Cookies Sie akzeptieren möchten",
      cookiesNecessary: "Notwendige Cookies",
      cookiesNecessaryDesc:
        "Immer aktiv - Diese Cookies sind für die Grundfunktionen der Website erforderlich",
      cookiesAnalytics: "Analyse",
      cookiesAnalyticsTitle: "Analyse-Cookies",
      cookiesAnalyticsDesc:
        "Diese Cookies sammeln Informationen über die Nutzung der Website, um sie zu verbessern. Alle gesammelten Daten sind anonymisiert.",
      cookiesMarketing: "Marketing",
      cookiesMarketingTitle: "Marketing-Cookies",
      cookiesMarketingDesc:
        "Diese Cookies werden verwendet, um Anzeigen zu personalisieren und die Effektivität von Werbekampagnen zu messen.",
      saveSettings: "Einstellungen speichern",

      // Analytics Consent
      analyticsConsentText:
        "Wir verwenden analysierende Cookies/Tools (Plausible/GA4), um unsere Website zu verbessern. Sie können zustimmen oder ablehnen.",
      decline: "Ablehnen",
      accept: "Zustimmen",
    },
  },
  en: {
    translation: {
      // UI Controls
      language: "Language",
      lightMode: "Light mode",
      darkMode: "Dark mode",
      menu: "Menu",
      backToTop: "Back to top",

      // Navigation
      home: "Home",
      services: "Services",
      contact: "Contact",
      references: "References",
      imprint: "Imprint",
      privacy: "Privacy",

      // Hero Section
      heroBadge: "Your Digital Transformation",
      heroTitle: "Your IT Solutions for the Digital Future",
      heroSubtitle:
        "From process optimization to software development – we offer comprehensive IT solutions for your company.",
      heroCta: "Get consultation now",
      ctaReady: "Ready to get started?",
      ctaEmail: "Write to us: {{email}}",

      // Services
      servicesTitle: "Our Services",
      servicesSubtitle:
        "From process optimization to software development – we offer comprehensive IT solutions for your company.",
      processOptimization: "Process Optimization",
      processOptimizationText:
        "Analyze workflows, eliminate waste, introduce automation.",
      softwareDevelopment: "Software Development",
      softwareDevelopmentText:
        "Custom web apps, integrations, interfaces – tailored for your business.",
      webSeo: "Websites & SEO",
      webSeoText: "Fast, converting websites with search engine optimization.",
      automation: "Automation & AI",
      automationText:
        "Bots, RPA and AI-powered tools that handle routine tasks.",
      itService: "IT Service",
      itServiceText:
        "Computer setup, email & cloud, backups, security – reliable.",
      support: "Support & Training",
      supportText: "Onboarding, workshops and ongoing support for your team.",
      inquire: "Inquire",
      requestConsultation: "Request free consultation",
      freeConsultation: "Free initial consultation",
      viewServices: "View services",
      inquirySubjectPrefix: "Inquiry:",
      learnMore: "Learn more",
      viewAllServices: "View all services",
      servicesCtaTitle: "Ready for the next step?",
      servicesCtaSubtitle:
        "Let's solve your IT challenges together and digitally transform your business.",

      // References
      referencesTitle: "Our References",
      referencesSubtitle: "Selected customer projects from SMEs and trades",
      referencesBadge: "Our Projects",
      referenceViewDetails: "View details",
      referenceVisitSite: "Visit website",
      referenceTech: "Technology Stack",
      referenceHighlights: "Highlights",
      referenceBack: "Back to References",
      referencesCtaTitle: "Your project next?",
      referencesCtaSubtitle: "Let's talk about your project",
      requestProject: "Request project",
      referenceDetailCtaTitle: "Planning a similar project?",
      referenceDetailCtaSubtitle: "Let's talk about your project",
      allReferences: "All references",

      // Process Steps
      processTitle: "Our Approach",
      step: "Step",
      step1: "Analysis",
      step1Text:
        "We analyze your current processes and identify optimization potential.",
      step2: "Concept",
      step2Text: "Together we develop a tailored concept for your IT solution.",
      step3: "Implementation",
      step3Text:
        "We implement your solution professionally and guide you through the process.",
      step4: "Support",
      step4Text:
        "Ongoing support and continuous optimization of your IT infrastructure.",

      // Contact
      contactTitle: "Contact us",
      contactSubtitle:
        "Do you have questions or would you like a non-binding consultation? We look forward to your message.",
      contactPageSubtitle:
        "Let's talk about your project. We look forward to your message!",
      contactInformation: "Contact information",
      name: "Name",
      email: "Email",
      company: "Company",
      phone: "Phone",
      subject: "Subject",
      message: "Message",
      send: "Send message",
      sendMessageTitle: "Send message",
      contactFormHelpText:
        "Describe your project or request. We'll get back to you as soon as possible.",
      required: "Required field",
      invalidEmail: "Please enter a valid email address.",
      invalidPhone: "Please enter a valid phone number",
      onRequest: "On request",
      writeUsMessage: "Write us a message",
      feelFreeToCallUs: "Feel free to call us",
      location: "Location",
      Germany: "Germany",
      remoteOnSitePossible: "Remote & on-site possible",
      itServicesAndSoftwareDevelopment: "IT services & software development",
      responseTime: "Response time",
      weRespondQuickly: "We respond quickly",
      responseTimeBadge: "Response time: < 24 hours",
      sending: "Sending...",
      allFieldsRequired: "All fields marked * are required",
      nameRequired: "Name is required",
      nameMin2: "Name must be at least 2 characters long",
      emailRequired: "Email is required",
      subjectRequired: "Subject is required",
      subjectMin3: "Subject must be at least 3 characters long",
      messageRequired: "Message is required",
      messageMin6: "Message must be at least 6 characters long",
      messageMin10: "Message must be at least 10 characters long",
      sendError: "Error sending",
      contactThanks24h: "Thank you! We'll get back to you within 24 hours.",
      sendFailed: "Sending failed. Please try again.",

      // Footer
      copyright: "© 2024 webmix-it.com. All rights reserved.",

      // Common
      themeToggle: "Toggle theme",
      languageSwitch: "Switch language",
      loading: "Loading...",
      error: "Error",
      errorOops: "Oops!",
      somethingWentWrong: "Something went wrong",
      success: "Success",
      close: "Close",
      back: "Back",
      next: "Next",
      save: "Save",
      cancel: "Cancel",
      delete: "Delete",
      edit: "Edit",
      view: "View",
      search: "Search",
      filter: "Filter",
      sort: "Sort",
      refresh: "Refresh",
      print: "Print",
      download: "Download",
      upload: "Upload",
      submit: "Submit",
      reset: "Reset",
      confirm: "Confirm",
      yes: "Yes",
      no: "No",
      ok: "OK",
      notFound: "Not found",
      notFoundTitle: "Page not found",
      notFoundDescription: "The requested page could not be found.",
      notFoundGoHome: "Go to homepage",
      notFoundGoBack: "Go back",
      notFoundContactSupport: "Contact support",
      helpfulLinks: "Helpful links",
      goToHome: "Go to homepage",
      exploreServices: "Services",
      getHelpSupport: "Contact",
      tryAgain: "Try again",
      reloadPage: "Reload page",
      reportError: "Report error",
      needHelp: "Need help?",
      contactUs: "Get in touch",
      errorIdLabel: "Error ID",

      // Cookie Consent
      cookieSettings: "Cookie settings",
      cookieBannerTextShort:
        "We use cookies to provide you the best experience on our website",
      cookieBannerDescription:
        "We use cookies and similar technologies to improve our website, save your preferences, and show you personalized content. You can change your settings at any time.",
      adjustSettings: "Adjust settings",
      acceptNecessary: "Necessary only",
      acceptAll: "Accept all",
      chooseCookies: "Choose which cookies you want to accept",
      cookiesNecessary: "Necessary cookies",
      cookiesNecessaryDesc:
        "Always active – These cookies are required for basic site functionality",
      cookiesAnalytics: "Analytics",
      cookiesAnalyticsTitle: "Analytics cookies",
      cookiesAnalyticsDesc:
        "These cookies collect information about website usage to improve it. All collected data is anonymized.",
      cookiesMarketing: "Marketing",
      cookiesMarketingTitle: "Marketing cookies",
      cookiesMarketingDesc:
        "These cookies are used to personalize ads and measure campaign effectiveness.",
      saveSettings: "Save settings",

      // Analytics Consent
      analyticsConsentText:
        "We use analytical cookies/tools (Plausible/GA4) to improve our website. You can accept or decline.",
      decline: "Decline",
      accept: "Accept",
    },
  },
  ta: {
    translation: {
      // UI Controls
      language: "மொழி",
      lightMode: "ஒளி பயன்முறை",
      darkMode: "இருள் பயன்முறை",
      menu: "பட்டியல்",
      backToTop: "மேல் செல்ல",

      // Navigation
      home: "முகப்பு",
      services: "சேவைகள்",
      contact: "தொடர்பு",
      references: "குறிப்புகள்",
      imprint: "அச்சிடு",
      privacy: "தனியுரிமை",

      // Hero Section
      heroBadge: "உங்கள் டிஜிட்டல் மாற்றம்",
      heroTitle: "டிஜிட்டல் எதிர்காலத்திற்கான உங்கள் IT தீர்வுகள்",
      heroSubtitle:
        "செயல்முறை மேம்பாட்டிலிருந்து மென்பொருள் உருவாக்கம் வரை – உங்கள் நிறுவனத்திற்கான விரிவான IT தீர்வுகளை நாங்கள் வழங்குகிறோம்.",
      heroCta: "இப்போது ஆலோசனை பெறுங்கள்",
      ctaReady: "தொடங்க தயாரா?",
      ctaEmail: "எங்களுக்கு எழுதுங்கள்: {{email}}",

      // Services
      servicesTitle: "எங்கள் சேவைகள்",
      servicesSubtitle:
        "செயல்முறை மேம்பாட்டிலிருந்து மென்பொருள் உருவாக்கம் வரை – உங்கள் நிறுவனத்திற்கான விரிவான IT தீர்வுகளை நாங்கள் வழங்குகிறோம்.",
      processOptimization: "செயல்முறை மேம்பாடு",
      processOptimizationText:
        "வேலைப்பாய்வுகளை பகுப்பாய்வு செய்தல், வீணானவற்றை நீக்குதல், தானியங்கியை அறிமுகப்படுத்துதல்.",
      softwareDevelopment: "மென்பொருள் உருவாக்கம்",
      softwareDevelopmentText:
        "தனிப்பட்ட வலை பயன்பாடுகள், ஒருங்கிணைப்புகள், இடைமுகங்கள் – உங்கள் வணிகத்திற்கு துல்லியமாக தயாரிக்கப்பட்டவை.",
      webSeo: "வலைத்தளங்கள் & SEO",
      webSeoText: "வேகமான, மாற்றும் வலைத்தளங்கள் தேடுபொறி மேம்பாட்டுடன்.",
      automation: "தானியங்கி & AI",
      automationText:
        "வழக்கமான பணிகளை எடுத்துக்கொள்ளும் போட்கள், RPA மற்றும் AI-இயக்கப்பட்ட கருவிகள்.",
      itService: "IT சேவை",
      itServiceText:
        "கணினிகளை மீட்டமைத்தல், மின்னஞ்சல் & கிளவுட், காப்புப்பிரதிகள், பாதுகாப்பு – நம்பகமானது.",
      support: "ஆதரவு & பயிற்சி",
      supportText:
        "உங்கள் குழுவிற்கான அறிமுகம், பட்டறைகள் மற்றும் தொடர்ச்சியான ஆதரவு.",
      inquire: "விசாரணை",
      requestConsultation: "இலவச ஆலோசனை கோருங்கள்",
      freeConsultation: "இலவச ஆரம்ப ஆலோசனை",
      viewServices: "சேவைகளை காண்க",
      inquirySubjectPrefix: "விசாரணை:",
      learnMore: "மேலும் அறிய",
      viewAllServices: "அனைத்து சேவைகளையும் பார்க்க",
      servicesCtaTitle: "அடுத்த படிக்கு தயாரா?",
      servicesCtaSubtitle:
        "உங்கள் IT சவால்களை சேர்ந்து தீர்த்து, உங்கள் நிறுவனத்தை டிஜிட்டலாக மாற்றுவோம்.",

      // References
      referencesTitle: "எங்கள் குறிப்புகள்",
      referencesSubtitle: "தொழில் மற்றும் சேவைத் துறைகளிலிருந்து தேர்ந்தெடுக்கப்பட்ட வாடிக்கையாளர் திட்டங்கள்",
      referencesBadge: "எங்கள் திட்டங்கள்",
      referenceViewDetails: "விவரங்களைப் பார்க்க",
      referenceVisitSite: "தளத்திற்குச் செல்ல",
      referenceTech: "தொழில்நுட்ப குவியல்",
      referenceHighlights: "முக்கிய அம்சங்கள்",
      referenceBack: "குறிப்புகளுக்கு திரும்பு",
      referencesCtaTitle: "உங்கள் திட்டம் அடுத்ததா?",
      referencesCtaSubtitle: "உங்கள் திட்டத்தைப் பற்றி பேசலாம்",
      requestProject: "திட்டம் கேட்க",
      referenceDetailCtaTitle: "இத்தகைய திட்டம் திட்டமிட்டுள்ளீர்களா?",
      referenceDetailCtaSubtitle: "உங்கள் திட்டத்தைப் பற்றி பேசலாம்",
      allReferences: "அனைத்து குறிப்புகள்",

      // Process Steps
      processTitle: "எங்கள் அணுகுமுறை",
      step: "படி",
      step1: "பகுப்பாய்வு",
      step1Text:
        "உங்கள் தற்போதைய செயல்முறைகளை நாங்கள் பகுப்பாய்வு செய்து மேம்பாட்டு திறனை அடையாளம் காண்கிறோம்.",
      step2: "கருத்து",
      step2Text:
        "உங்கள் IT தீர்வுக்கான தனிப்பயனாக்கப்பட்ட கருத்தை நாங்கள் ஒன்றாக உருவாக்குகிறோம்.",
      step3: "செயல்படுத்துதல்",
      step3Text:
        "உங்கள் தீர்வை நாங்கள் தொழில்முறையாக செயல்படுத்தி அறிமுகப்படுத்தும் போது உங்களுடன் இருக்கிறோம்.",
      step4: "ஆதரவு",
      step4Text:
        "உங்கள் IT உள்கட்டமைப்பின் தொடர்ச்சியான ஆதரவு மற்றும் தொடர்ச்சியான மேம்பாடு.",

      // Contact
      contactTitle: "எங்களைத் தொடர்பு கொள்ளுங்கள்",
      contactSubtitle:
        "உங்களுக்கு கேள்விகள் உள்ளனவா அல்லது கட்டுப்பாடற்ற ஆலோசனை விரும்புகிறீர்களா? உங்கள் செய்திக்காக நாங்கள் காத்திருக்கிறோம்.",
      contactPageSubtitle:
        "உங்கள் திட்டத்தைப் பற்றி பேசலாம். உங்கள் செய்திக்காக நாங்கள் காத்திருக்கிறோம்!",
      contactInformation: "தொடர்பு தகவல்",
      name: "பெயர்",
      email: "மின்னஞ்சல்",
      company: "நிறுவனம்",
      phone: "தொலைபேசி",
      subject: "பொருள்",
      message: "செய்தி",
      send: "செய்தியை அனுப்பு",
      sendMessageTitle: "செய்தியை அனுப்பு",
      contactFormHelpText:
        "உங்கள் திட்டம் அல்லது கோரிக்கையை விவரிக்கவும். எங்களால் முடிந்த விரைவில் தொடர்பு கொள்கிறோம்.",
      required: "தேவையான புலம்",
      invalidEmail: "சரியான மின்னஞ்சல் முகவரியை உள்ளிடவும்.",
      invalidPhone: "சரியான தொலைபேசி எண்ணை உள்ளிடவும்",
      onRequest: "கோரிக்கைப்படி",
      writeUsMessage: "எங்களுக்கு ஒரு செய்தி எழுதுங்கள்",
      feelFreeToCallUs: "எங்களை அழைக்கவும்",
      location: "இடம்",
      Germany: "ஜெர்மனி",
      remoteOnSitePossible: "தொலைவிலும் மற்றும் தளத்திலும்",
      itServicesAndSoftwareDevelopment: "IT சேவைகள் & மென்பொருள் உருவாக்கம்",
      responseTime: "பதில் நேரம்",
      weRespondQuickly: "நாங்கள் விரைவில் பதிலளிப்போம்",
      responseTimeBadge: "பதில் நேரம்: < 24 மணி",
      sending: "அனுப்புகிறது...",
      allFieldsRequired: "* அடையாளமிடப்பட்ட அனைத்து புலங்களும் தேவையானவை",
      nameRequired: "பெயர் தேவையானது",
      nameMin2: "பெயர் குறைந்தது 2 எழுத்துகள் இருக்க வேண்டும்",
      emailRequired: "மின்னஞ்சல் தேவையானது",
      subjectRequired: "பொருள் தேவையானது",
      subjectMin3: "பொருள் குறைந்தது 3 எழுத்துகள் இருக்க வேண்டும்",
      messageRequired: "செய்தி தேவையானது",
      messageMin6: "செய்தி குறைந்தது 6 எழுத்துகள் இருக்க வேண்டும்",
      messageMin10: "செய்தி குறைந்தது 10 எழுத்துகள் இருக்க வேண்டும்",
      sendError: "அனுப்பும்போது பிழை",
      contactThanks24h:
        "நன்றி! 24 மணி நேரத்திற்குள் நாங்கள் தொடர்பு கொள்கிறோம்.",
      sendFailed: "அனுப்பு தோல்வியடைந்தது. தயவுசெய்து மீண்டும் முயற்சிக்கவும்.",

      // Footer
      copyright: "© 2024 webmix-it.com. அனைத்து உரிமைகளும் பாதுகாக்கப்பட்டவை.",

      // Common
      themeToggle: "தீம் மாற்று",
      languageSwitch: "மொழி மாற்று",
      loading: "ஏற்றுகிறது...",
      error: "பிழை",
      errorOops: "அச்சு!",
      somethingWentWrong: "ஏதோ தவறு நடந்துள்ளது",
      success: "வெற்றி",
      close: "மூடு",
      back: "திரும்பு",
      next: "அடுத்து",
      save: "சேமி",
      cancel: "ரத்து செய்",
      delete: "நீக்கு",
      edit: "திருத்து",
      view: "பார்க்க",
      search: "தேடு",
      filter: "வடிகட்டி",
      sort: "வரிசைப்படுத்து",
      refresh: "புதுப்பி",
      print: "அச்சிடு",
      download: "பதிவிறக்கு",
      upload: "பதிவேற்று",
      submit: "சமர்ப்பி",
      reset: "மீட்டமை",
      confirm: "உறுதிப்படுத்து",
      yes: "ஆம்",
      no: "இல்லை",
      ok: "சரி",
      notFound: "கிடைக்கவில்லை",
      notFoundTitle: "பக்கம் கிடைக்கவில்லை",
      notFoundDescription: "கோரப்பட்ட பக்கம் கிடைக்கவில்லை.",
      notFoundGoHome: "முகப்புக்குச் செல்",
      notFoundGoBack: "திரும்பு",
      notFoundContactSupport: "ஆதரவைத் தொடர்பு கொள்",
      helpfulLinks: "பயனுள்ள இணைப்புகள்",
      goToHome: "முகப்புக்குச் செல்",
      exploreServices: "சேவைகள்",
      getHelpSupport: "தொடர்பு",
      tryAgain: "மீண்டும் முயற்சி செய்",
      reloadPage: "பக்கத்தை புதுப்பிக்கவும்",
      reportError: "பிழையை அறிவிக்கவும்",
      needHelp: "உங்களுக்கு உதவி தேவைதா?",
      contactUs: "எங்களைத் தொடர்பு கொள்ளுங்கள்",
      errorIdLabel: "பிழை-அடை",

      // Cookie Consent
      cookieSettings: "குக்கி அமைப்புகள்",
      cookieBannerTextShort:
        "எங்கள் இணையதளத்தில் உங்களுக்கு சிறந்த அனுபவத்தை வழங்க நாங்கள் குக்கிகளைப் பயன்படுத்துகிறோம்",
      cookieBannerDescription:
        "எங்கள் இணையதளத்தை மேம்படுத்த, உங்கள் விருப்பங்களைச் சேமிக்க, மற்றும் தனிப்பயனாக்கப்பட்ட உள்ளடக்கத்தை காட்ட குக்கிகள் மற்றும் இதே போன்ற தொழில்நுட்பங்களைப் பயன்படுத்துகிறோம். நீங்கள் எந்த நேரத்திலும் உங்கள் அமைப்புகளை மாற்றலாம்.",
      adjustSettings: "அமைப்புகளை மாற்றவும்",
      acceptNecessary: "தேவையானவை மட்டுமே",
      acceptAll: "அனைத்தையும் ஏற்கவும்",
      chooseCookies: "நீங்கள் ஏற்க விரும்பும் குக்கிகளைத் தேர்ந்தெடுக்கவும்",
      cookiesNecessary: "தேவையான குக்கிகள்",
      cookiesNecessaryDesc:
        "எப்போதும் செயலில் – அடிப்படை தள செயல்பாட்டிற்கு இந்த குக்கிகள் தேவையானவை",
      cookiesAnalytics: "பகுப்பாய்வு",
      cookiesAnalyticsTitle: "பகுப்பாய்வு குக்கிகள்",
      cookiesAnalyticsDesc:
        "இத்தளத்தின் பயன்பாட்டைப் பற்றிய தகவலை சேகரித்து மேம்படுத்த பயன்படுகிறது. சேகரிக்கப்பட்ட அனைத்து தரவும் பெயரறியாமையாகும்.",
      cookiesMarketing: "மார்க்கெட்டிங்",
      cookiesMarketingTitle: "மார்க்கெட்டிங் குக்கிகள்",
      cookiesMarketingDesc:
        "விளம்பரங்களை தனிப்பயனாக்கவும், பிரச்சார செயல்திறனை அளக்கவும் இந்த குக்கிகள் பயன்படுத்தப்படுகின்றன.",
      saveSettings: "அமைப்புகளை சேமிக்கவும்",

      // Analytics Consent
      analyticsConsentText:
        "எங்கள் இணையதளத்தை மேம்படுத்த (Plausible/GA4) பகுப்பாய்வு குக்கிகளைப் பயன்படுத்துகிறோம். நீங்கள் ஏற்கவோ மறுக்கவோ முடியும்.",
      decline: "மறுக்கவும்",
      accept: "ஏற்கவும்",
    },
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "de",
  fallbackLng: "de",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
